import React, { useState, useEffect } from 'react';
import api from '../services/api';

const Weekrapport = () => {
  const [data, setData] = useState(null);
  const [datum, setDatum] = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [emailNaar, setEmailNaar] = useState('');
  const [emailSubj, setEmailSubj] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [sending, setSending] = useState(false);

  const load = async () => {
    setLoading(true);
    try { const r = await api.get(`/rapportage/week?datum=${datum}`); setData(r.data); }
    catch (e) { console.error(e); }
    setLoading(false);
  };
  useEffect(() => { load(); }, [datum]);

  useEffect(() => {
    if (data) {
      setEmailSubj(`Weekrapport ${data.huidige_week.start} t/m ${data.volgende_week.end}`);
      setEmailBody(`Hierbij het weekrapport voor ${data.huidige_week.start} t/m ${data.volgende_week.end}.\n\nMet vriendelijke groet`);
    }
  }, [data]);

  const sendEmail = async () => {
    if (!emailNaar || !emailNaar.includes('@')) return alert('Vul een geldig e-mailadres in');
    setSending(true);
    try {
      const r = await api.post(`/rapportage/week/email?datum=${datum}`, { naar: emailNaar, onderwerp: emailSubj, bericht: emailBody });
      alert(r.data.message || 'E-mail verstuurd');
      setShowEmail(false);
    } catch (e) { alert('Mislukt: ' + (e?.response?.data?.message || e.message)); }
    setSending(false);
  };

  const downloadPdf = async () => {
    try {
      const r = await api.get(`/rapportage/week/pdf?datum=${datum}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url; a.download = `weekrapport-${datum}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (e) { alert('Download mislukt'); }
  };

  const card = { background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', marginBottom: 16 };
  const title = (c) => ({ fontSize: 16, fontWeight: 600, color: c, marginBottom: 10 });
  const row = { padding: '10px 0', borderBottom: '1px solid #f3f4f6' };
  const fmt = (d) => d ? String(d).slice(0,10) : '';

  const renderRow = (r, datumLabel, badge) => (
    <div key={r.id} style={row}>
      <div style={{ fontWeight: 500 }}>{r.titel}{badge}</div>
      <div style={{ fontSize: 12, color: '#6b7280' }}>
        {datumLabel} · {r.klant_naam}{r.ordernummer ? ' · ' + r.ordernummer : ''}{r.monteurs ? ' · ' + r.monteurs : ''}
      </div>
    </div>
  );

  return (
    <div style={{ padding: 20, maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0 }}>📊 Weekrapport</h2>
        <input type="date" value={datum} onChange={e => setDatum(e.target.value)}
               style={{ padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6 }} />
        <button onClick={downloadPdf} disabled={!data || loading}
                style={{ padding: '8px 14px', background: '#10b981', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 500 }}>
          ⬇️ Download PDF
        </button>
        <button onClick={() => setShowEmail(true)} disabled={!data || loading}
                style={{ padding: '8px 14px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 500 }}>
          📧 E-mail
        </button>
      </div>

      {loading && <div style={{ color: '#6b7280' }}>Laden...</div>}
      {data && (<>
        <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 12 }}>
          Deze week: {data.huidige_week.start} t/m {data.huidige_week.end} · Volgende week: {data.volgende_week.start} t/m {data.volgende_week.end}
        </div>

        <div style={card}>
          <div style={title('#059669')}>✓ Deze week — Afgerond ({data.afgerond.length})</div>
          {data.afgerond.length === 0
            ? <div style={{ color: '#9ca3af', fontSize: 13 }}>(geen)</div>
            : data.afgerond.map(r => renderRow(r, fmt(r.afgerond_op), null))}
        </div>

        <div style={card}>
          <div style={title('#dc2626')}>✗ Deze week — Niet afgerond ({data.niet_afgerond.length})</div>
          {data.niet_afgerond.length === 0
            ? <div style={{ color: '#9ca3af', fontSize: 13 }}>(geen)</div>
            : data.niet_afgerond.map(r => <NietAfgerondRij key={r.id} wo={r} onSaved={load} />)}
        </div>

        {/* Monteur-prestaties */}
        {data.monteur_stats && data.monteur_stats.length > 0 && (
          <div style={card}>
            <div style={title('#7c3aed')}>👷 Monteur-prestaties deze week</div>
            {data.monteur_stats.map(m => {
              const pct = m.gepland > 0 ? Math.round((m.afgerond / m.gepland) * 100) : 0;
              const kleur = pct >= 80 ? '#059669' : (pct >= 50 ? '#d97706' : '#dc2626');
              return (
                <div key={m.id} style={{ padding: '8px 0', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ flex: '0 0 180px', fontSize: 13, fontWeight: 500 }}>{m.naam}</div>
                  <div style={{ flex: '0 0 90px', fontSize: 12, color: '#6b7280' }}>{m.afgerond} / {m.gepland}</div>
                  <div style={{ flex: 1, height: 8, background: '#f3f4f6', borderRadius: 4, overflow: 'hidden' }}>
                    <div style={{ width: `${Math.min(100, pct)}%`, height: '100%', background: kleur, transition: 'width 0.3s' }} />
                  </div>
                  <div style={{ flex: '0 0 50px', fontSize: 13, fontWeight: 600, color: kleur, textAlign: 'right' }}>{pct}%</div>
                </div>
              );
            })}
          </div>
        )}

        {/* Feestdagen */}
        {(data.feestdagen_vorige?.length || data.feestdagen_volgende?.length) ? (
          <div style={card}>
            <div style={title('#ea580c')}>🎉 Feestdagen in deze periode</div>
            {[...(data.feestdagen_vorige||[]), ...(data.feestdagen_volgende||[])].map((f, idx) => (
              <div key={idx} style={{ padding: '6px 0', fontSize: 13, color: '#9a3412' }}>
                <strong>{f.datum}</strong> — {f.naam}
              </div>
            ))}
          </div>
        ) : null}

        <div style={card}>
          <div style={title('#2563eb')}>📅 Volgende week — Gepland ({data.gepland.length})</div>
          {data.gepland.length === 0
            ? <div style={{ color: '#9ca3af', fontSize: 13 }}>(geen)</div>
            : data.gepland.map(r => renderRow(r, fmt(r.geplande_datum), null))}
        </div>
      </>)}
    {showEmail && (
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }} onClick={(e) => { if (e.target === e.currentTarget) setShowEmail(false); }}>
        <div style={{ background: 'white', borderRadius: 12, padding: 24, width: '100%', maxWidth: 500 }}>
          <h3 style={{ margin: '0 0 16px 0' }}>📧 Weekrapport e-mailen</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Naar *</label>
              <input type="email" value={emailNaar} onChange={e => setEmailNaar(e.target.value)} placeholder="naam@bedrijf.nl"
                     style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Onderwerp</label>
              <input type="text" value={emailSubj} onChange={e => setEmailSubj(e.target.value)}
                     style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Bericht</label>
              <textarea value={emailBody} onChange={e => setEmailBody(e.target.value)} rows={5}
                        style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' }} />
            </div>
            <div style={{ fontSize: 12, color: '#6b7280' }}>📎 PDF van weekrapport ({datum}) wordt als bijlage meegestuurd.</div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
              <button onClick={() => setShowEmail(false)} disabled={sending}
                      style={{ padding: '8px 14px', background: 'white', border: '1px solid #d1d5db', borderRadius: 6, cursor: 'pointer' }}>
                Annuleer
              </button>
              <button onClick={sendEmail} disabled={sending || !emailNaar}
                      style={{ padding: '8px 14px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: 6, cursor: sending ? 'wait' : 'pointer', fontWeight: 500 }}>
                {sending ? '⏳ Versturen...' : '📤 Verstuur'}
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
    </div>
  );
};


const row2 = { padding: '10px 0', borderBottom: '1px solid #f3f4f6' };
function NietAfgerondRij({ wo, onSaved }) {
  const [reden, setReden] = React.useState(wo.afmeld_opmerking || '');
  const [saving, setSaving] = React.useState(false);
  const [dirty, setDirty] = React.useState(false);
  const fmtD = (d) => d ? String(d).slice(0,10) : '';

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/werkorders/${wo.id}/afmeld-opmerking`, { reden });
      setDirty(false);
      if (onSaved) onSaved();
    } catch (e) { alert('Opslaan mislukt'); }
    setSaving(false);
  };

  return (
    <div style={row2}>
      <div style={{ fontWeight: 500 }}>{wo.titel}
        <span style={{ fontSize: 11, color: '#92400e', background: '#fef3c7', padding: '2px 8px', borderRadius: 4, marginLeft: 6 }}>{wo.status || 'open'}</span>
      </div>
      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 6 }}>
        gepland {fmtD(wo.geplande_datum)} · {wo.klant_naam}{wo.ordernummer ? ' · ' + wo.ordernummer : ''}{wo.monteurs ? ' · ' + wo.monteurs : ''}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          type="text"
          value={reden}
          placeholder="Reden waarom niet uitgevoerd..."
          onChange={e => { setReden(e.target.value); setDirty(true); }}
          style={{ flex: 1, padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13 }}
        />
        <button onClick={save} disabled={!dirty || saving}
                style={{ padding: '6px 12px', background: dirty ? '#10b981' : '#e5e7eb', color: dirty ? 'white' : '#9ca3af', border: 'none', borderRadius: 6, cursor: dirty ? 'pointer' : 'default', fontSize: 13 }}>
          {saving ? '⏳' : '💾 Opslaan'}
        </button>
      </div>
    </div>
  );
}


export default Weekrapport;
